module.exports = __webpack_public_path__ + "static/media/LPM.24f28af8.png";